(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loruvio-header"]) return;
  try {
    
function initialiseLoruvioMenus(root) {
  root.querySelectorAll('[data-loruvio-header]').forEach(header => {
    if (header.dataset.menuReady) return;
    header.dataset.menuReady = 'true';
    const menus = [...header.querySelectorAll('.lsh-mega')];
    menus.forEach(menu => {
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
      });
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const openMenu = header.querySelector('details[open]');
      if (openMenu) { openMenu.open = false; openMenu.querySelector('summary').focus(); }
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    });
  });
}
initialiseLoruvioMenus(document);
document.addEventListener('shopify:section:load', event => initialiseLoruvioMenus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
